import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Legalpage.css';

const SECTIONS = [
  { id: 'responsable',    num: '01', label: 'Responsable du traitement' },
  { id: 'collecte',       num: '02', label: 'Données collectées' },
  { id: 'finalites',      num: '03', label: 'Finalités du traitement' },
  { id: 'base',           num: '04', label: 'Base légale' },
  { id: 'conservation',   num: '05', label: 'Durée de conservation' },
  { id: 'destinataires',  num: '06', label: 'Destinataires' },
  { id: 'droits',         num: '07', label: 'Vos droits' },
  { id: 'securite',       num: '08', label: 'Sécurité' },
  { id: 'cookies',        num: '09', label: 'Cookies' },
  { id: 'contact',        num: '10', label: 'Contact' },
];

export default function PolitiqueConfidentialite() {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <div className="legal">

        <div className="legal__hero">
          <div className="legal__hero-inner container">
            <button className="legal__back" onClick={() => navigate(-1)} type="button">
              <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M19 12H5M12 5l-7 7 7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Retour
            </button>
            <h1 className="legal__title">Politique de confidentialité</h1>
            <p className="legal__subtitle">Mise à jour le 25 mars 2026 · Conforme RGPD</p>
          </div>
        </div>

        <div className="legal__body">
          <div className="container">
            <div className="legal__grid">

              <aside className="legal__toc">
                <p className="legal__toc-title">Sommaire</p>
                <ul className="legal__toc-list">
                  {SECTIONS.map(s => (
                    <li key={s.id}>
                      <a href={`#${s.id}`} className="legal__toc-link">{s.label}</a>
                    </li>
                  ))}
                </ul>
              </aside>

              <main className="legal__content">

                <div className="legal__info-box" style={{ marginBottom: '2.5rem' }}>
                  <p>La protection de vos données personnelles est une priorité pour SOCLIMATE. La présente politique décrit comment nous collectons, utilisons et protégeons vos informations conformément au RGPD du 27 avril 2016.</p>
                </div>

                <section id="responsable" className="legal__section">
                  <span className="legal__section-num">01</span>
                  <h2 className="legal__section-title">Responsable du traitement</h2>
                  <table className="legal__table">
                    <tbody>
                      <tr><th>Société</th><td>SOCLIMATE</td></tr>
                      <tr><th>Forme juridique</th><td>SAS — Société par actions simplifiée</td></tr>
                      <tr><th>SIRET</th><td>991 881 194 00013</td></tr>
                      <tr><th>Représentant légal</th><td>Isaac ERRAJI</td></tr>
                      <tr><th>Adresse</th><td>1 rue de Belloy, 95570 Villaines-sous-Bois</td></tr>
                      <tr><th>Email</th><td>contact@soclimate.fr</td></tr>
                    </tbody>
                  </table>
                </section>

                <section id="collecte" className="legal__section">
                  <span className="legal__section-num">02</span>
                  <h2 className="legal__section-title">Données collectées</h2>
                  <p>Dans le cadre de notre activité, nous collectons les catégories de données suivantes :</p>
                  <ul>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Données d'identification</strong> — nom, prénom, adresse email, numéro de téléphone ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Données de localisation</strong> — adresse postale pour les interventions ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Données de navigation</strong> — adresse IP, type de navigateur, pages consultées ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Données contractuelles</strong> — informations relatives à vos demandes de devis et interventions.</li>
                  </ul>
                  <p>Aucune donnée sensible au sens de l'article 9 du RGPD n'est collectée.</p>
                </section>

                <section id="finalites" className="legal__section">
                  <span className="legal__section-num">03</span>
                  <h2 className="legal__section-title">Finalités du traitement</h2>
                  <p>Vos données sont traitées pour les finalités suivantes :</p>
                  <ul>
                    <li>Traitement et suivi de vos demandes de devis et de contact ;</li>
                    <li>Exécution des contrats de prestation de services ;</li>
                    <li>Gestion de la relation client et suivi des interventions ;</li>
                    <li>Facturation et obligations comptables et fiscales ;</li>
                    <li>Amélioration de nos services et de l'expérience utilisateur ;</li>
                    <li>Envoi d'informations commerciales, uniquement avec votre consentement.</li>
                  </ul>
                </section>

                <section id="base" className="legal__section">
                  <span className="legal__section-num">04</span>
                  <h2 className="legal__section-title">Base légale des traitements</h2>
                  <p>Chaque traitement repose sur une base légale conforme à l'article 6 du RGPD :</p>
                  <ul>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Exécution du contrat</strong> — pour le traitement de vos demandes et la réalisation des prestations ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Obligation légale</strong> — pour la facturation et les obligations comptables ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Intérêt légitime</strong> — pour l'amélioration de nos services et la sécurité du site ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Consentement</strong> — pour les communications commerciales et les cookies non essentiels.</li>
                  </ul>
                </section>

                <section id="conservation" className="legal__section">
                  <span className="legal__section-num">05</span>
                  <h2 className="legal__section-title">Durée de conservation</h2>
                  <ul>
                    <li>Données clients et contractuelles : <strong style={{ color: 'rgba(255,255,255,0.68)' }}>5 ans</strong> après la fin de la relation commerciale ;</li>
                    <li>Données de facturation : <strong style={{ color: 'rgba(255,255,255,0.68)' }}>10 ans</strong> (obligations légales comptables) ;</li>
                    <li>Données de prospection : <strong style={{ color: 'rgba(255,255,255,0.68)' }}>3 ans</strong> à compter du dernier contact ;</li>
                    <li>Cookies analytiques : <strong style={{ color: 'rgba(255,255,255,0.68)' }}>13 mois</strong> maximum ;</li>
                    <li>Demandes de devis sans suite : <strong style={{ color: 'rgba(255,255,255,0.68)' }}>1 an</strong>.</li>
                  </ul>
                </section>

                <section id="destinataires" className="legal__section">
                  <span className="legal__section-num">06</span>
                  <h2 className="legal__section-title">Destinataires des données</h2>
                  <p>Vos données sont destinées exclusivement aux personnes habilitées au sein de SOCLIMATE. Elles ne sont jamais vendues à des tiers.</p>
                  <p>Elles peuvent être transmises à des sous-traitants techniques (hébergeur, messagerie) dans le strict cadre des services, liés par des obligations de confidentialité conformes au RGPD.</p>
                </section>

                <section id="droits" className="legal__section">
                  <span className="legal__section-num">07</span>
                  <h2 className="legal__section-title">Vos droits</h2>
                  <p>Conformément aux articles 15 à 22 du RGPD, vous disposez des droits suivants :</p>
                  <ul>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Droit d'accès</strong> — obtenir une copie de vos données traitées ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Droit de rectification</strong> — corriger des données inexactes ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Droit à l'effacement</strong> — demander la suppression de vos données ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Droit à la limitation</strong> — restreindre le traitement dans certains cas ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Droit à la portabilité</strong> — recevoir vos données dans un format structuré ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Droit d'opposition</strong> — vous opposer au traitement ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Retrait du consentement</strong> — à tout moment pour les traitements basés sur le consentement.</li>
                  </ul>
                  <div className="legal__info-box">
                    <p>Pour exercer vos droits : <strong style={{ color: 'rgba(255,255,255,0.78)' }}>contact@soclimate.fr</strong> — SOCLIMATE, 1 rue de Belloy, 95570 Villaines-sous-Bois. Réponse sous 1 mois. En cas de réponse insatisfaisante, vous pouvez saisir la <strong style={{ color: 'rgba(255,255,255,0.72)' }}>CNIL — www.cnil.fr</strong></p>
                  </div>
                </section>

                <section id="securite" className="legal__section">
                  <span className="legal__section-num">08</span>
                  <h2 className="legal__section-title">Sécurité des données</h2>
                  <p>SOCLIMATE met en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données :</p>
                  <ul>
                    <li>Chiffrement des communications via protocole HTTPS (TLS) ;</li>
                    <li>Accès aux données restreint aux seules personnes habilitées ;</li>
                    <li>Hébergement chez un prestataire certifié et sécurisé ;</li>
                    <li>Sauvegardes régulières des données.</li>
                  </ul>
                </section>

                <section id="cookies" className="legal__section">
                  <span className="legal__section-num">09</span>
                  <h2 className="legal__section-title">Gestion des cookies</h2>
                  <p>Notre site utilise trois catégories de cookies :</p>
                  <ul>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Cookies strictement nécessaires</strong> — indispensables au fonctionnement, pas de consentement requis ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Cookies analytiques</strong> — mesure d'audience, soumis à consentement ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Cookies de préférences</strong> — mémorisent vos choix pour personnaliser l'expérience.</li>
                  </ul>
                  <p>Vous pouvez gérer vos préférences à tout moment via le bandeau cookies ou les paramètres de votre navigateur.</p>
                </section>

                <section id="contact" className="legal__section">
                  <span className="legal__section-num">10</span>
                  <h2 className="legal__section-title">Contact</h2>
                  <table className="legal__table">
                    <tbody>
                      <tr><th>Email</th><td>contact@soclimate.fr</td></tr>
                      <tr><th>Courrier</th><td>SOCLIMATE — 1 rue de Belloy, 95570 Villaines-sous-Bois</td></tr>
                      <tr><th>Autorité de contrôle</th><td>CNIL — 3 place de Fontenoy, 75007 Paris · www.cnil.fr</td></tr>
                    </tbody>
                  </table>
                </section>

              </main>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}